<template>
    <div class="online-renewal-questions-container">
        <v-container>

            <v-layout row wrap>
                <v-flex md6>
                    <button class="transparent-button"
                    v-show="$store.state.onlineRenewalStep > 1"
                    @click="$emit('decrementStep')">
                        <IconBase><IconArrowBack /></IconBase>&nbsp;&nbsp;BACK
                    </button>
                </v-flex>
                <v-flex md4 offset-md2
                v-if="nswText">
                    <v-layout row wrap class="nsw-text mb-20">
                        <v-flex md1 xs2>
                            <div class="icon-circle-wrapper">
                                <IconBase class="icon"><IconSmallBusiness /></IconBase>
                            </div>
                        </v-flex>
                        <v-flex md11 xs10>
                            As general guidance, a small business is an individual, partnership company or trust turning over less than $2 million aggregated turnover* per year.
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>

            <v-layout row wrap>
                <v-flex md4 offset-md4>
                    <center>
                        <h1 v-html="title" class="question-title"></h1>
                        <p v-html="question" class="question-content"></p>
                    </center>

                    <v-layout row wrap class="mb-50">
                        <v-flex md6>
                            <button class="blue-button"
                            @click="setDeclarations(true)">YES</button>
                        </v-flex>
                        <v-flex md6>
                            <button class="blue-button"
                            @click="setDeclarations(false)">NO</button>
                        </v-flex>
                    </v-layout>

                    <div v-html="additionalText" v-if="additionalText"></div>

                </v-flex>
            </v-layout>

        </v-container>
    </div>
</template>

<script>

export default {
    name: "OnlineRenewalQuestions",
    props: {
        title: String,
        question: String,
        additionalText: String,
        nswText: Boolean
    },
    methods: {
        setDeclarations($value) {
            switch(this.title) {
                case 'Previous policies':
                    this.$emit('previousPoliciesDeclaration', $value);
                break;

                case 'Existing claims':
                    this.$emit('existingClaimsDeclaration', $value);
                break;

                case 'Previous claims':
                    this.$emit('previousClaimsDeclaration', $value);
                break;

                case 'NSW Small Business Exemption':
                    this.$emit('nswSmallBusinessExemptionDeclaration', $value);
                break;
            }
        }
    }
}
</script>

<style lang="css" scoped>
    .online-renewal-questions-container {
        background-color: white;
        min-height: 64vh;
    }
    .question-title {
        color: #D93B20;
        font-weight: bolder;
        margin-bottom: 20px;
    }
    .question-content {
        margin-bottom: 50px;
    }
    .blue-button:first-child {
        float: right;
    }
    .blue-button:last-child {
        float: left;
    }
    .nsw-text {
        background-color: #58B7DD;
        border-radius: 5pt;
        color: white;
        display: flex;
        align-items: center;
        padding: 10px 20px;
    }
    .nsw-text div:nth-child(2) {
        padding-left: 20px;
    }
    .icon-circle-wrapper {
        background-color: white;
        border-radius: 100%;
        color: #58B7DD;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        width: 40px;
    }
    .icon-circle-wrapper .icon {
        height: 25px;
        width: 25px;
    }
</style>